import { Box, Button, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'

interface DialogComprarHistoriasProps {
  open: boolean
  setOpen: (op: boolean) => void
  banner: string
  link: string
}

const DialogComprarHistorias = ({ open, setOpen, banner, link }: DialogComprarHistoriasProps) => {
  if (!link || !banner) return <></>

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        style: {
          display: 'flex',
          maxWidth: '100%',
          maxHeight: '100%'
        }
      }}
    >
      <Box sx={{ padding: 0 }}>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            fontSize: '8px'
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ padding: 0 }}>
          <img
            src={banner}
            alt=""
            style={{
              objectFit: 'contain',
              maxWidth: '100%',
              maxHeight: '80vh',
              margin: 0,
              padding: 0
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button fullWidth variant="contained" color="success" onClick={() => window.open(link, '_blank')}>
            Comprar
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DialogComprarHistorias
